import { create } from 'zustand';

type ModalSize = 'sm' | 'md' | 'lg';
type ModalVariant = 'destructive' | 'warning' | 'default';

export interface ConfirmationState {
  open: boolean;
  title: string | null;
  description?: string | null;
  cancelLabel: string | null;
  actionLabel: string | null;
  content?: React.ReactNode;
  size?: ModalSize;
  variant?: ModalVariant;
  onAction: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  isSubmitting?: 'submit' | 'cancel' | null;
}

export interface ConfirmationActions {
  openConfirmation: (data: {
    title: string;
    description?: string;
    cancelLabel: string;
    actionLabel: string;
    content?: React.ReactNode;
    size?: ModalSize;
    variant?: ModalVariant;
    onAction?: () => void | Promise<void>;
    onCancel?: () => void | Promise<void>;
    isSubmitting?: 'submit' | 'cancel' | null;
  }) => void;
  closeConfirmation: () => void;
  setSubmitting: (isSubmitting: 'submit' | 'cancel' | null) => void;
}

const useConfirmationStore = create<ConfirmationState & ConfirmationActions>((set) => ({
  open: false,
  title: null,
  description: null,
  cancelLabel: null,
  actionLabel: null,
  onAction: () => {},
  onCancel: () => {},
  isSubmitting: null,
  setSubmitting: (value) => set({ isSubmitting: value }),
  openConfirmation: (data) =>
    set(() => ({
      open: true,
      title: data.title,
      description: data.description,
      cancelLabel: data.cancelLabel,
      actionLabel: data.actionLabel,
      content: data.content,
      variant: data.variant,
      size: data?.size,
      onAction: data.onAction,
      onCancel: data.onCancel,
      isSubmitting: null,
    })),
  closeConfirmation: () =>
    set({
      open: false,
      title: null,
      description: null,
      cancelLabel: null,
      actionLabel: null,
      content: undefined,
      size: undefined,
      variant: undefined,
      onAction: () => {},
      onCancel: () => {},
      isSubmitting: null,
    }),
}));

export { useConfirmationStore };
